import {
  type BillStatus,
  enumBillStatus,
  enumInvoiceStatus,
  enumPaymentStatus,
  type InvoiceStatus,
  type PaymentStatus,
} from '@rematter/frontend-lib-api-client';
import type { ThemeColor } from '@rematter/ui-web';

export const colorByBillStatus: Record<BillStatus, ThemeColor> = {
  [enumBillStatus.Pending]: 'warning',
  [enumBillStatus.Paid]: 'success',
  [enumBillStatus.Voided]: 'failure',
};

export const colorByInvoiceStatus: Record<InvoiceStatus, ThemeColor> = {
  [enumInvoiceStatus.ProForma]: 'neutral',
  [enumInvoiceStatus.Pending]: 'warning',
  [enumInvoiceStatus.Paid]: 'success',
  [enumInvoiceStatus.Voided]: 'failure',
};

export const colorByPaymentStatus: Record<PaymentStatus, ThemeColor> = {
  [enumPaymentStatus.Issued]: 'warning',
  [enumPaymentStatus.Posted]: 'success',
  [enumPaymentStatus.Voided]: 'failure',
  [enumPaymentStatus.VoidedWriteOff]: 'failure',
};
